module.exports = __webpack_public_path__ + "img/5.9b70eaa9.webp";